/** Matches common Tailwind `max-h-[120px]` chat inputs. */
export const CHAT_TEXTAREA_MAX_HEIGHT_PX = 120

/**
 * Sets textarea height to fit content up to maxHeightPx; enables vertical scroll when capped.
 */
export function syncTextareaAutosizeHeight(el: HTMLTextAreaElement, maxHeightPx: number): void {
  el.style.height = 'auto'
  const scrollHeight = el.scrollHeight
  const nextHeight = Math.min(scrollHeight, maxHeightPx)
  el.style.height = `${nextHeight}px`
  el.style.overflowY = scrollHeight > maxHeightPx ? 'auto' : 'hidden'
}
